import { Component } from "@theme/component";

const BASE_CLASS = "header-od-menu";
const MENU_CLASS = `${BASE_CLASS}__menu`;
const PANEL_CLASS = `${BASE_CLASS}__panel`;
const ACTIVE_CLASS = `${PANEL_CLASS}--active`;

class HeaderOdMenu extends Component {
  #rootPanel: Element | null = null;

  connectedCallback(): void {
    super.connectedCallback();

    this.#rootPanel = this.querySelector(`.${PANEL_CLASS}--level-0`);

    const colorScheme = this.dataset.colorScheme ?? ""; // TODO: default?

    // Set color scheme for top-level panels
    this.querySelectorAll(
      `.${PANEL_CLASS}:not(.${PANEL_CLASS} .${PANEL_CLASS})`,
    ).forEach((panel) => panel.classList.add(colorScheme));
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
  }

  /**
   * Keeps aria-expanded on this menu's trigger button(s) in sync with whether
   * the root panel is actually open, since this is a custom toggle (not a
   * native <details>/<summary> pair that would track this on its own).
   */
  #syncTriggerState(): void {
    const isOpen = this.#rootPanel?.classList.contains(ACTIVE_CLASS) ?? false;

    document
      .querySelectorAll(`[aria-controls="${this.id}"]`)
      .forEach((trigger) =>
        trigger.setAttribute("aria-expanded", String(isOpen)),
      );
  }

  handleLinkClick(e: Event) {
    e.preventDefault();

    const btn = e.target;
    if (!btn || !(btn instanceof HTMLElement)) return;

    const parentMenu = btn.closest(`.${MENU_CLASS}`);
    const childPanel = btn.parentElement?.querySelector(`.${PANEL_CLASS}`);

    // close other links at this level
    parentMenu
      ?.querySelectorAll(`.${PANEL_CLASS}`)
      .forEach((panel) => panel.classList.remove(ACTIVE_CLASS));

    // open child panel
    childPanel?.classList.add(ACTIVE_CLASS);
  }

  handleOpen(e: Event) {
    e.preventDefault();
    this.#rootPanel?.classList.add(ACTIVE_CLASS);
    this.#syncTriggerState();
  }

  handleToggle(e: Event) {
    e.preventDefault();
    this.#rootPanel?.classList.toggle(ACTIVE_CLASS);
    this.#syncTriggerState();
  }

  handleClose(e: Event) {
    e.preventDefault();

    // close all panels
    this.querySelectorAll(`.${PANEL_CLASS}`).forEach((panel) =>
      panel.classList.remove(ACTIVE_CLASS),
    );
    this.#syncTriggerState();
  }

  handleClosePanel(e: Event) {
    e.preventDefault();

    const btn = e.target;
    if (!btn || !(btn instanceof HTMLElement)) return;

    const parentPanel = btn.closest(`.${PANEL_CLASS}`);

    // close parent panel
    parentPanel?.classList.remove(ACTIVE_CLASS);
    // close children panels
    parentPanel?.querySelectorAll(`.${PANEL_CLASS}`).forEach((panel) => {
      panel.classList.remove(ACTIVE_CLASS);
    });
    this.#syncTriggerState();
  }
}

if (!customElements.get("header-od-menu")) {
  customElements.define("header-od-menu", HeaderOdMenu);
}
